module.exports = __webpack_public_path__ + "static/media/vf_wwallet_core.f7bcf485.svg";